module.exports = __webpack_public_path__ + "static/media/one.75bfa841.png";